import React from 'react';
import { Line } from '@react-three/drei';
import * as THREE from 'three';

interface DottedPreviewLineProps {
  startPoint: THREE.Vector3;
  endPoint: THREE.Vector3;
  color?: string;
  dashSize?: number;
  gapSize?: number;
  lineWidth?: number;
}

/**
 * Renders a 3D dotted/dashed line between two points using drei's Line.
 */
export const DottedPreviewLine: React.FC<DottedPreviewLineProps> = ({
  startPoint,
  endPoint,
  color = '#ff6b6b',
  dashSize = 0.2,
  gapSize = 0.1,
  lineWidth = 2,
}) => {
  const points = React.useMemo(() => [
    startPoint.clone(),
    endPoint.clone(),
  ], [startPoint, endPoint]);

  return (
    <Line
      points={points}
      color={color}
      lineWidth={lineWidth}
      dashed
      dashSize={dashSize}
      gapSize={gapSize}
    />
  );
}; 